(function () {
  /* Carousel init — one call per section instance. Instance ids are queued
     by a tiny inline cfg script in sections/rings_by_style_sega_26.liquid (window.__spxCfg_ringsByStyle). */
  function spxInitOne(containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;

  const track = container.querySelector('.sega-carousel-track');
  let originalItems = Array.from(track.querySelectorAll('.sega-carousel-item'));
  const dots = Array.from(container.querySelectorAll('.sega-dot'));
  
  // Clone logic: Ensure at least 10 items for smooth infinite loop visual
  const MIN_ITEMS = 10;
  let items = [...originalItems];
  
  if (originalItems.length > 0) {
      while(items.length < MIN_ITEMS) {
          originalItems.forEach(item => {
              const clone = item.cloneNode(true);
              // Mark as clone to avoid event listener dupes if any (none here)
              clone.classList.add('cloned');
              track.appendChild(clone);
              items.push(clone);
          });
      }
  }

  // State
  let currentIndex = 0; // Virtual index to track rotation
  let startX = 0;
  let currentX = 0;
  let isDragging = false;
  let animationId;
  
  // Configuration
  const VISIBLE_COUNT = 5; // We want 5 items visible pattern
  const ITEM_WIDTH_PERCENT = 28; // % of container width
  const SPACING_PERCENT = 25; // Distance between centers in %
  
  function updateCarousel() {
    const containerWidth = container.offsetWidth;
    const centerX = containerWidth / 2;
    
    // We base everything on `currentIndex` + drag offset
    // Drag offset needs to be converted to "index units"
    // 1 unit = SPACING_PERCENT of width
    const dragOffsetPercent = (currentX / containerWidth) * 100;
    const dragIndexOffset = dragOffsetPercent / SPACING_PERCENT;
    
    const effectiveIndex = currentIndex - dragIndexOffset;
    
    items.forEach((item, i) => {
      // Calculate distance from center (in index units)
      // Normalize i relative to effectiveIndex using modulo for infinite loop feel?
      // Actually standard infinite loop usually resets position.
      // Let's use a simpler circular positioning math.
      
      const totalItems = items.length;
      
      // Calculate circular distance with robust modulo for infinite wrapping
      let diff = i - effectiveIndex;
      let offset = ((diff % totalItems) + totalItems) % totalItems; // [0, totalItems)
      if (offset > totalItems / 2) offset -= totalItems; // [-total/2, total/2]
      
      // Logic for Visual Styles based on offset
      // offset = 0 => Center
      // offset = +/- 1 => Sides
      // offset = +/- 2 => Edges

      // Configuration from data attribute
      const settings = JSON.parse(container.getAttribute('data-settings'));
      const sCenterImg = settings.centerImg;
      const sSideImg = settings.sideImg;
      const sEdgeImg = settings.edgeImg;
      
      const sCenterTxt = settings.centerTxt;
      const sSideTxt = settings.sideTxt;
      const sEdgeTxt = settings.edgeTxt;
       
       const autoplayDuration = settings.autoplay * 1000;
       
       // Autoplay Logic
       if (!window.segaAutoplayInit && autoplayDuration > 0) {
           window.segaAutoplayInit = true; // Prevent multiple inits if resized/called again
           let autoplayTimer;
           
           function startAutoplay() {
               stopAutoplay();
               autoplayTimer = setInterval(() => {
                   if (!isDragging) {
                       snapTo(Math.round(currentIndex) + 1);
                   }
               }, autoplayDuration);
           }
           
           function stopAutoplay() {
               if (autoplayTimer) clearInterval(autoplayTimer);
           }
           
           // Start initially
           startAutoplay();
           
           // Pause on interaction
           container.addEventListener('touchstart', stopAutoplay, {passive: true});
           container.addEventListener('touchend', startAutoplay);
           
           // Pause if not visible (Intersection Observer could be added for performance)
       }
      
      const absOffset = Math.abs(offset);
      
      // Calculate X position (percent) relative to center
      const xPosPercent = offset * SPACING_PERCENT;
      
      // Continuous Scale Logic (Image)
      let scale = sEdgeImg;
      if (absOffset <= 1.0) {
          // Center (0) -> Side (1)
          scale = sCenterImg + (sSideImg - sCenterImg) * absOffset;
      } else if (absOffset <= 2.0) {
          // Side (1) -> Edge (2)
          const t = absOffset - 1.0;
          scale = sSideImg + (sEdgeImg - sSideImg) * t;
      } else {
          // Edge (2) -> Far
          scale = sEdgeImg;
      }
      
      // Z-Index & Opacity Logic
      let zIndex = 1;
      let opacity = 1;
      
      if (absOffset < 0.5) {
         zIndex = 10;
         item.classList.add('active');
      } else if (absOffset < 1.5) {
         zIndex = 5;
         item.classList.remove('active');
      } else if (absOffset < 2.5) {
         zIndex = 2;
         item.classList.remove('active');
      } else {
         zIndex = 1;
         item.classList.remove('active');
         // Fade out far items to prevent popping
         if (absOffset > 2.5) opacity = 0;
      }
      
      // Visibility Cull
      if (absOffset > 3.5) { // Increased margin slightly
          item.style.display = 'none';
      } else {
          item.style.display = 'flex';
      }

      // Apply Styles to Item Container (Position only, no scale)
      item.style.transform = `translate(calc(-50% + ${xPosPercent}vw), 0)`; 
      item.style.zIndex = zIndex;
      item.style.opacity = opacity;
      
      // Apply Scale to Image Wrapper Independenty
      const imgWrap = item.querySelector('.sega-carousel-image-wrap');
      if (imgWrap) {
          imgWrap.style.transform = `scale(${scale})`;
      }
      
      // Update Title Text Scale smoothly
      const title = item.querySelector('.sega-carousel-title');
      if(title) {
          title.style.opacity = 1;
          
          let txtScale = sEdgeTxt;
          if (absOffset <= 1.0) {
             txtScale = sCenterTxt + (sSideTxt - sCenterTxt) * absOffset;
          } else if (absOffset <= 2.0) {
             const t = absOffset - 1.0;
             txtScale = sSideTxt + (sEdgeTxt - sSideTxt) * t;
          }
          
          title.style.transform = `scale(${txtScale})`;
      }
      
    });

    // Real-time Dot Tracking
    // We want the dot to change as soon as the item crosses the midpoint threshold (0.5)
    // currentIndex represents the center point. 
    // Math.round(currentIndex) gives the index of the item closest to center.
    
    // Normalize currentIndex to positive range [0, originalItems.length]
    let normalized = currentIndex % originalItems.length;
    if (normalized < 0) normalized += originalItems.length;
    
    // Snap to nearest integer for active state
    // If normalized is 4.6 -> 5. If 4.4 -> 4.
    const activeDotIndex = Math.round(normalized) % originalItems.length;
    
    dots.forEach((dot, idx) => {
        if (idx === activeDotIndex) dot.classList.add('active');
        else dot.classList.remove('active');
    });
  }
  
  // Events
  container.addEventListener('touchstart', (e) => {
      isDragging = true;
      startX = e.touches[0].clientX;
      // Stop any auto momentum/snap animation
      cancelAnimationFrame(animationId);
  }, {passive: true});
  
  container.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const x = e.touches[0].clientX;
      currentX = x - startX;
      requestAnimationFrame(updateCarousel);
  }, {passive: true});
  
  container.addEventListener('touchend', (e) => {
      isDragging = false;
      
      // Determine snap target
      const containerWidth = container.offsetWidth;
      const dragOffsetPercent = (currentX / containerWidth) * 100;
      const dragIndexOffset = dragOffsetPercent / SPACING_PERCENT;
      
      // Update real index
      currentIndex -= dragIndexOffset;
      
      // Snap to nearest integer
      const targetIndex = Math.round(currentIndex);
      
      // Animate snap
      snapTo(targetIndex);
      
      currentX = 0; // Reset drag delta
  });
  
  // Dot Click Event
  dots.forEach(dot => {
      dot.addEventListener('click', (e) => {
          e.preventDefault();
          const targetIndex = parseInt(dot.getAttribute('data-index'), 10);
          const originalCount = originalItems.length;
          
          // Calculate current visual position
          let currentMod = currentIndex % originalCount;
          if (currentMod < 0) currentMod += originalCount;
          
          // Calculate shortest path
          let diff = targetIndex - currentMod;
          
          if (diff > originalCount / 2) {
              diff -= originalCount;
          } else if (diff < -originalCount / 2) {
              diff += originalCount;
          }
          
          const targetVal = currentIndex + diff;
          snapTo(targetVal);
      });
  });
  
  function snapTo(target) {
      const start = currentIndex;
      const dist = target - start;
      const duration = 300; // ms
      const startTime = performance.now();
      
      function animate(time) {
          const elapsed = time - startTime;
          const progress = Math.min(elapsed / duration, 1);
          
          // Ease In Out Cubic for smoother start/stop
          const ease = progress < 0.5 
              ? 4 * progress * progress * progress 
              : 1 - Math.pow(-2 * progress + 2, 3) / 2;
          
          currentIndex = start + (dist * ease);
          updateCarousel();
          
          if (progress < 1) {
              animationId = requestAnimationFrame(animate);
          } else {
             currentIndex = target; // Ensure exact final value
             // Normalize currentIndex to prevent huge numbers
             const total = items.length;
             currentIndex = (currentIndex % total + total) % total;
             updateCarousel();
             /* 2026-05-22: removed `updateDots()` call — function was never
                defined in this section, throwing a ReferenceError on home.
                Dot active-state isn't currently wired; if dots become a
                visible feature, define updateDots() before re-adding the call. */
          }
      }
      animationId = requestAnimationFrame(animate);
  }

  // Initial Draw
  updateCarousel();
  }

  function spxRun() {
    var q = window.__spxCfg_ringsByStyle || [];
    while (q.length) spxInitOne(q.shift());
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', spxRun);
  } else {
    spxRun();
  }
})();
